import { Component, OnInit } from '@angular/core';
import { SUCURSALES } from '../../../_config/strings';
import { NgForOf, getLocaleId } from '@angular/common';
import { ObjectUnsubscribedError } from 'rxjs';
import { getQueryValue } from '@angular/core/src/view/query';
// import { _getComponentHostLElementNode } from '@angular/core/src/render3/instructions';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.scss']
})
export class FormularioComponent implements OnInit {

  SUCURSALES: any;
  currentSucursal: any;
  resultado: any;

  constructor(
    public router: Router
  ) {
    this.SUCURSALES = SUCURSALES;
  }

  // Fecha
  fecha = moment().locale('es').format('LL');

  // Para mostrar en el formulario (Meta de sucursal)
  fnombre = '';
  fmeta = '';
  fsuma = '';
  fgerente1 = '';
  fgerente2 = '';
  fgerente3 = '';
  fgerente4 = '';
  fporcentaje1 = '';
  fporcentaje2 = '';
  fporcentaje3 = '';
  fporcentaje4 = '';
  fdecimal1 = '';
  fdecimal2 = '';
  fdecimal3 = '';
  fdecimal4 = '';
  ftotalcomisiones = 0;
  fmetadesucursal = 0;
  // Operaciones enlazadas para mostrar en el formulario
  operacionuno = 0;
  operaciondos = 0;
  operaciontre = 0;
  operacioncua = 0;
  operacionsei = 0;
  operacionsie = 0;
  operacionoch = 0;
  operacionextra = 0;
  operacionextrados = 0;
  operacionextratre = 0;
  operacionextracua = 0;
  operacionextracin = 0;
  operacioncomision = 0;
  operaciontmc = 0;
  operacionctr = 0;
  operacionultimo = 0;
  comision1 = 0;
  comision2 = 0;
  comision3 = 0;
  comision4 = 0;
  iva = 1.16;
  // Conver
  converuno: any;
  converdos: any;
  convertre: any;
  convercua: any;
  convercin: any;
  conversei: any;
  conversie: any;
  converoch: any;
  convernue: any;
  converdie: any;
  convercom1: any;
  convercom2: any;
  convercom3: any;
  convercom4: any;
  convertotal: any;
  convernomina: any;
  converctr: any;
  convertcs: any;
  converultimo: any;
  // Meta de sucursal
  tcb = 0;
  tcj = 0;
  c_ext = 0;
  // Cobranza renta con IVA
  c_rrIVA = 0;
  c_rrconIVA = 0;
  crcI2 = 0;
  cvcI = 0;
  // Cobranza sin IVA renta
  csIr = Number;
  menosSueldosMontaje = 0;
  menosgastos = Number;
  // --
  snoventa = Number;
  // Integracion por gastos
  fletes = 0;
  ndeducibles = 0;
  maniobras = 0;
  boletosAvion = 0;
  hospedaje = 0;
  transporte = 0;
  alimentos = 0;
  casetas = 0;
  combuylubri = 0;
  combuylubriEDEN = 0;
  combuylubriAPOYOS = 0;
  gastosfletes = 0;
  noDeduciblesObra = 0;
  otro = 0;
  // Nomina
  nominanombre = 0;
  nIAI = 0;
  nImpuesto = 0;


  ngOnInit() {
    this.dameSucursal();
  }

  dameSucursal() {
    var mostrandoJ = JSON.parse(localStorage.getItem('sucursal_sesion'));
    const resultado = this.SUCURSALES.find( sucursal => sucursal.codSuc === mostrandoJ.codSuc );
    // Obtención de datos
    var vmetadesucursal = resultado.metadesucursal;
    var sucursal = resultado.nombre;
    var meta = resultado.metaTope;
    var suma = resultado.sumaSuc;
    // ==()
    var empleado1 = resultado.gerente1;
    var empleado2 = resultado.gerente2;
    var empleado3 = resultado.gerente3;
    var empleado4 = resultado.gerente4;
    var porcen1 = resultado.porcentaje1;
    var porcen2 = resultado.porcentaje2;
    var porcen3 = resultado.porcentaje3;
    var porcen4 = resultado.porcentaje4;
    var decimal1 = resultado.pdecimal1;
    var decimal2 = resultado.pdecimal2;
    var decimal3 = resultado.pdecimal3;
    var decimal4 = resultado.pdecimal4;
    // ==()
    // Mostrar en formulario
    this.fmetadesucursal = vmetadesucursal;
    this.fnombre = sucursal;
    this.fmeta = meta;
    this.fsuma = suma;
    this.fgerente1 = empleado1;
    this.fgerente2 = empleado2;
    this.fgerente3 = empleado3;
    this.fgerente4 = empleado4;
    this.fporcentaje1 = porcen1;
    this.fporcentaje2 = porcen2;
    this.fporcentaje3 = porcen3;
    this.fporcentaje4 = porcen4;
    this.fdecimal1 = decimal1;
    this.fdecimal2 = decimal2;
    this.fdecimal3 = decimal3;
    this.fdecimal4 = decimal4;
  }

  mostraruno() {
    // this.formatDollar(this.tcb);
    this.operacionuno = Number(this.tcb) - Number(this.tcj) + Number(this.c_ext);
    this.converuno = this.formatDollar(this.operacionuno);
  }

  mostrardos() {
    this.operaciondos = Number(this.c_rrIVA) + Number(this.cvcI);
    this.converdos = this.formatDollar(this.operaciondos);
    // console.log(this.converdos);
    this.operacionextra = Number(this.c_rrIVA) / Number(this.iva);
    this.convertre = this.formatDollar(this.operacionextra);
    // console.log(this.convertre);
    this.operacionextrados = Number(this.cvcI) / Number(this.iva);
    this.convercua = this.formatDollar(this.operacionextrados);
    // console.log(this.convercua);
  }

  mostrartres() {
    if (this.operacionsei == 0) {
      Swal('Importante', 'Ingresa primero los datos: Integración por gastos', 'warning');
      // this.operaciontre = 0;
      this.menosSueldosMontaje = 0;
    } else {
      // this.operaciontre = Number(this.operacionextra) - Number(this.menosSueldosMontaje) - Number(this.operacionsei);
      // this.convernue = this.formatDollar(this.operaciontre);
    }
    //
    this.operaciontre = Number(this.operacionextra) - Number(this.menosSueldosMontaje) - Number(this.operacionsei);
    this.convernue = this.formatDollar(this.operaciontre);
    // console.log(this.convernue);
    this.operacionextratre = Number(this.operaciontre) * 0.10;
    this.convercin = this.formatDollar(this.operacionextratre);
    // console.log(this.convercin);
    this.operacionextracua = Number(this.operacionextrados) * 0.05;
    this.conversei = this.formatDollar(this.operacionextracua);
    // console.log(this.conversei);
    this.operacionextracin = Number(this.operacionextratre) + Number(this.operacionextracua);
    this.conversie = this.formatDollar(this.operacionextracin);
    // console.log(this.conversie);
  }

  mostrarseis() {
    // tslint:disable-next-line:max-line-length
    this.operacionsei = Number(this.fletes) + Number(this.ndeducibles) + Number(this.maniobras) + Number(this.boletosAvion) + Number(this.hospedaje) + Number(this.transporte) + Number(this.alimentos) + Number(this.casetas) + Number(this.combuylubri) + Number(this.combuylubriEDEN) + Number(this.combuylubriAPOYOS) + Number(this.gastosfletes) + Number(this.noDeduciblesObra);
    this.converoch = this.formatDollar(this.operacionsei);
    // console.log(this.converoch);
  }

  mostrarsiete() {
    //
    // ()
    if (this.fmetadesucursal <= this.tcb) {
      this.operacionultimo = Number(this.operacionextracin) - Number(this.snoventa);
      this.converctr = this.formatDollar(this.operacionultimo);
      // this.converctr = this.formatDollar(this.operacionextracin);
      this.comision1 = Number(this.operacionultimo) * Number(this.fdecimal1);
      this.convercom1 = this.formatDollar(this.comision1);
      this.comision2 = Number(this.operacionultimo) * Number(this.fdecimal2);
      this.convercom2 = this.formatDollar(this.comision2);
      this.comision3 = Number(this.operacionultimo) * Number(this.fdecimal3);
      this.convercom3 = this.formatDollar(this.comision3);
      this.comision4 = Number(this.operacionultimo) * Number(this.fdecimal4);
      this.convercom4 = this.formatDollar(this.comision4);
    } else {
        this.operacionctr = Number(this.operaciontmc) - Number(this.snoventa);
        this.converctr = this.formatDollar(this.operacionctr);
        this.comision1 = Number(this.operacionctr) * Number(this.fdecimal1);
        this.convercom1 = this.formatDollar(this.comision1);
        this.comision2 = Number(this.operacionctr) * Number(this.fdecimal2);
        this.convercom2 = this.formatDollar(this.comision2);
        this.comision3 = Number(this.operacionctr) * Number(this.fdecimal3);
        this.convercom3 = this.formatDollar(this.comision3);
        this.comision4 = Number(this.operacionctr) * Number(this.fdecimal4);
        this.convercom4 = this.formatDollar(this.comision4);
    }
    // ()
    // __--==this.operacionoch = Number(this.operacionextracin) - Number(this.snoventa);
    // __--==this.converdie = this.formatDollar(this.operacionoch);
    // --==
    this.ftotalcomisiones = Number(this.comision1) + Number(this.comision2) + Number(this.comision3) + Number(this.comision4);
    this.convertotal = this.formatDollar(this.ftotalcomisiones);
  }

  mostrarocho() {
    // Cálculo comisión
    if (this.fmetadesucursal <= this.tcb) {
      this.convernomina = 0;
      this.converdie = this.formatDollar(this.operacionextracin);
    } else {
      this.operacioncomision = Number(this.nominanombre) + Number(this.nIAI) + Number(this.nImpuesto);
      this.convernomina = this.formatDollar(this.operacioncomision);
      this.operaciontmc = Number(this.operacionextracin) - Number(this.operacioncomision);
      this.converdie = this.formatDollar(this.operaciontmc);
    }
  }

  public formatDollar(num) {
    let p = num.toFixed(2).split('.');
    return '$' + p[0].split('').reverse().reduce(function(acc, num, i, orig) {
        return num + (i && !(i % 3) ? ' , ' : '') + acc;
    }, '') + '.' + p[1];
  }

  cerrar() {
    localStorage.removeItem('sucursal_sesion');
    this.router.navigate(['/login']);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <style>
            .letraImprimir {
              font-family: Arial, Helvetica, sans-serif;
              font-size: 12px;
            }
            .tablaIntegracionGastos{
              border-bottom: 1px solid black;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/comisiones/formulario/formulario.component.ts